import { Card, Typography } from '@mui/material'
import { Fragment } from 'react'
import { formatUpdateNumber } from '../../../helper/formatAmount';
import kontenFrame from "../../../assets/icons/kontenFrame.svg";
import { kontencardColors } from '../../../content/content';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

const KontenCard = ({ konten, handleEdit, size }) => {
    const { t } = useTranslation();
    const formatIban = (iban) => {
        let formattedIban = iban.match(/.{1,4}/g).join('  ');
        return formattedIban;
    }

    return (
        <Fragment>
            {konten.map((item, i) => (
                <Grid item size={size} key={i}>
                    <Card className="card-bg" onClick={() => handleEdit(item)} sx={{ cursor: "pointer" }}>
                        <Typography
                            className="konten-card-data"
                            gutterBottom
                            sx={{
                                color: '#fff',
                                fontSize: 14,
                                background: kontencardColors[i % kontencardColors.length],
                                borderRadius: "20px",
                            }}
                        >
                            <Typography>
                                <img src={kontenFrame} alt="kontenFrame" className="konten-frame" />                           </Typography>
                            <Typography className="konten-card-content" sx={{ color: "#fff" }}>
                                {
                                    item.isManual && <span className="manual">{t('konten_card_manual')}</span>
                                }
                                <h3 className="bank-name">{item.bank_name}</h3>
                                <pre className="konten-card-number">{formatIban(item?.iban)}</pre>
                                <div className="konten-card-amount">
                                    {formatUpdateNumber(item.kontostand ? item.kontostand : item.ausstehender_betrag)} {item.currency ? item?.currency?.split("-")[0] : ""}
                                </div>
                                <Typography sx={{
                                    color: '#fff !important',
                                    font: 'Poppins',
                                    fontSize: 12,
                                    paddingTop: 1
                                }}>
                                    {t('konten_last_updatedAt')}: {dayjs(item?.updatedAt).format('DD.MM.YYYY. HH:mm:ss')}
                                </Typography>
                            </Typography>
                        </Typography>
                    </Card>
                </Grid>
            ))}
        </Fragment >
    )
}

export default KontenCard

